/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TrainingNoteVisibility {
    Public = 'PUBLIC',
    Private = 'PRIVATE'
}


export function instanceOfTrainingNoteVisibility(value: any): boolean {
    for (const key in TrainingNoteVisibility) {
        if (Object.prototype.hasOwnProperty.call(TrainingNoteVisibility, key)) {
            if (TrainingNoteVisibility[key as keyof typeof TrainingNoteVisibility] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrainingNoteVisibilityFromJSON(json: any): TrainingNoteVisibility {
    return TrainingNoteVisibilityFromJSONTyped(json, false);
}

export function TrainingNoteVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingNoteVisibility {
    return json as TrainingNoteVisibility;
}

export function TrainingNoteVisibilityToJSON(value?: TrainingNoteVisibility | null): any {
    return value as any;
}

export function TrainingNoteVisibilityToJSONTyped(value: any, ignoreDiscriminator: boolean): TrainingNoteVisibility {
    return value as TrainingNoteVisibility;
}

